"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
// sets the selected insurance
function SET_SELECTED_INSURANCE(state, selected) {
    state.selected = selected;
}
exports.SET_SELECTED_INSURANCE = SET_SELECTED_INSURANCE;
// sets the insurance list after api call
function SET_LIST(state, data) {
    state.list = data;
}
exports.SET_LIST = SET_LIST;
// cache the last request signature to prevent concurrency issues
function SET_LOADING(state, key) {
    state.loading = key;
}
exports.SET_LOADING = SET_LOADING;
// sets the price of the insurance
function SET_PRICE(state, price) {
    var index = lodash_1.findIndex(state.list, lodash_1.find(state.list, function (item) {
        return price.code === item.code;
    }));
    if (state.list && lodash_1.isNumber(index) && index > -1) {
        state.list[index].price = price.price;
    }
}
exports.SET_PRICE = SET_PRICE;
// saves a price differ from book
function SET_PRICE_DIFFER(state, priceDiffer) {
    var diff = lodash_1.remove(state.priceDiffer, function (item) {
        return priceDiffer.code === item.code;
    });
    state.priceDiffer.push(priceDiffer);
}
exports.SET_PRICE_DIFFER = SET_PRICE_DIFFER;
function SET_PRICES_WITH_PRICE_DIFFER(state) {
    for (var _i = 0, _a = state.priceDiffer; _i < _a.length; _i++) {
        var priceDiffer = _a[_i];
        SET_PRICE(state, priceDiffer);
    }
}
exports.SET_PRICES_WITH_PRICE_DIFFER = SET_PRICES_WITH_PRICE_DIFFER;
function SET_CHANNEL(state, channel) {
    state.channel = channel;
}
exports.SET_CHANNEL = SET_CHANNEL;
function RESET_STATE(state) {
    state.channel = 'IBE';
    state.list = [];
    state.loading = '';
    state.priceDiffer = [];
    state.selected = '';
}
exports.RESET_STATE = RESET_STATE;
// export everything compliant to the vuex specification for getters
exports.default = {
    RESET_STATE: RESET_STATE,
    SET_LIST: SET_LIST,
    SET_PRICE: SET_PRICE,
    SET_PRICE_DIFFER: SET_PRICE_DIFFER,
    SET_LOADING: SET_LOADING,
    SET_PRICES_WITH_PRICE_DIFFER: SET_PRICES_WITH_PRICE_DIFFER,
    SET_SELECTED_INSURANCE: SET_SELECTED_INSURANCE,
    SET_CHANNEL: SET_CHANNEL
};
//# sourceMappingURL=mutations.js.map